import { PM_PROVIDERS } from 'common/constants/constants';
import { useSelector } from 'react-redux';
import { pmToolSensorIdSelector } from 'state/selectors/sensors-authorizations';
import { RESOURCE_TYPES } from '../../resource_types';

const DEFAULT_RESOURCE_TYPE_BY_PM_TOOL = {
  [PM_PROVIDERS.JIRA]: RESOURCE_TYPES.JIRA_ISSUE_TYPES,
  [PM_PROVIDERS.AZURE_BOARDS]: RESOURCE_TYPES.AZURE_WORK_ITEMS
};

const useDefaultResourceType = () => {
  const pmToolSensorId = useSelector(pmToolSensorIdSelector);
  const defaultResourceType =
    DEFAULT_RESOURCE_TYPE_BY_PM_TOOL[pmToolSensorId] ||
    RESOURCE_TYPES.JIRA_ISSUE_TYPES;

  return defaultResourceType;
};

export default useDefaultResourceType;
